export default "__VITE_ASSET__B5zIj2____"